export enum MessageRole {
    User = "user",
    Assistant = "assistant"
}
